<template>
  <div>
    <div class="table-filters">
      <v-select
        v-model="currentHistoryType"
        class="filter"
        :items="dropdownItems"
        item-text="name"
        color="accent"
        :placeholder="currentHistoryType.length ? '' : 'Все'"
        label="Тип события"
        multiple
        clearable
        clear-icon="clear"
      />

      <div class="filter-wrap">
        <v-text-field
          v-model="searchId"
          class="filter"
          append-icon="search"
          label="ID пользователя"
          single-line
          color="accent"
          hide-details
          type="number"
        />

        <v-select
          v-model="currentAdmin"
          class="filter"
          :items="adminsList"
          item-text="name"
          item-value="id"
          color="accent"
          label="Админ"
        />

        <div style="display: flex; flex-direction: column;">
          <p>Выберите дату и время</p>

          <v-datetime-picker
            v-model="dateFrom"
            color="accent"
            label="Выберите дату от"
          />

          <v-datetime-picker
            v-model="dateTo"
            color="accent"
            label="Выберите дату до"
          />
        </div>
      </div>
    </div>

    <paginated-table
      ref="table"
      :pull-function="getHistory"
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <template #items="{ item }">
        <tr @click="openModal(item)">
          <td>
            {{ `${formDateTimeSec(item.created_at)}` }}
          </td>
          <td>
            {{ item.user.name }}
          </td>
          <td>
            {{ item.message || item.action }}
          </td>
        </tr>
      </template>
    </paginated-table>

    <v-dialog v-model="modal" max-width="fit-content">
      <v-card v-if="modalItem">
        <v-card-title class="modal-title" primary-title>
          {{ `Info - ${formDate(modalItem.created_at)} ${formatDateTime(modalItem.created_at)} - ${modalItem.action}` }}
        </v-card-title>
        <v-card-text>
          <div v-if="modalItem.parameters" class="parameters">
            <template v-for="(value, key, i) in modalItem.parameters">
              <div>{{ i + 1 }}. <span class="key">{{ key }}:</span> {{ value }}</div>
            </template>
          </div>
          <span v-else> Параметров нет </span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import PaginatedTable from '@/components/PaginatedTable.vue'
import { getHistoryRequest, getHistoryRequestCategories } from '../../api/history'
import VueMixin from '@/components/VueMixin.vue'
import api from '@/api'

export default {
  name: 'AdminLogs',
  components: { PaginatedTable },
  mixins: [VueMixin],
  data () {
    return {
      searchId: '',
      items: [],
      modalItem: null,
      modal: false,
      headers: [
        { text: 'DateTime', value: 'created_at' },
        { text: 'Админ', value: 'user.name' },
        { text: 'Действие', value: 'action' }
      ],
      currentHistoryType: [],
      currentAdmin: null,
      dropdownItems: [],
      adminsList: [],
      dateTo: null,
      dateFrom: null,
      loading: true,
      pagination: {
        sortBy: 'created_at',
        descending: true
      }
    }
  },
  watch: {
    currentHistoryType: 'resetAndGetHistory',
    currentAdmin: 'resetAndGetHistory',
    dateFrom: 'resetAndGetHistory',
    dateTo: 'resetAndGetHistory',
    searchId: debounce(function (v) {
      this.getHistory(1)
    }, 200)
  },
  mounted () {
    getHistoryRequestCategories().then(res => {
      if (!res.data.length > 0) return
      this.dropdownItems = res.data.map(item => ({
        name: item.title,
        value: item.type
      }))
    })

    this.getHistory(1)

    api.users.get({
      limit: 50, offset: 0, roles: [2, 3, 5]
    }).then(({ data }) => {
      this.adminsList = data
      if (this.adminsList.length > 0)
        this.adminsList.unshift({
          name: 'Все',
          id: null
        })
    })
  },
  methods: {
    resetAndGetHistory () {
      this.pagination.page = 1
      this.$refs.table.$refs.pagination.page = 1
      this.$refs.table.$refs.pagination.pages = 1
      this.getHistory(1)
    },
    getHistory (page) {
      const params = {
        user_id: this.searchId || undefined,
        admin_id: this.currentAdmin || undefined,
        type: this.currentHistoryType.length ? this.currentHistoryType : undefined,
        date_from: this.dateFrom ? this.formatDateFilter(this.dateFrom) : undefined,
        date_to: this.dateTo ? this.formatDateFilter(this.dateTo) : undefined
      }

      this.loading = true
      getHistoryRequest({
        limit: 26, offset: (page - 1) * 25, ...params
      })
        .then(response => {
          this.items = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openModal (item) {
      this.modalItem = item
      this.modal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.table-filters{
  display:flex;
  align-items: flex-start;
  justify-content: space-between;
}

.filter-wrap{
  display: flex;
  gap: 2rem;
}

.filter{
  max-width: 300px;
}

.filter ::v-deep input::placeholder {
  color: #fff !important;
}

.search-input {
  max-width: 300px;
  margin-inline-start: auto;
}
.modal-title{
  font-weight: 500;
  font-size: 18px;
  justify-content: center;
}
.parameters{
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 14px;
  .key{
    font-weight: 500;
  }
}
</style>
